//import './App.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Layout } from 'antd';
import CelebrationWrapper from './CelebrationWrapper'; 
import { BridgeAndProvider } from './auth/BridgeAndProvider'; 
import './styles.less';


const App = () => {
  return (

    <BridgeAndProvider>
    <Layout className="app">

    <Layout.Header>
        <h1>Celebration Config Hatch Demo App</h1>
    </Layout.Header>
                
    <Layout.Content>
        <CelebrationWrapper  />
    </Layout.Content>
    
    </Layout>
</BridgeAndProvider>
  );
 
};

const domNode = document.getElementById( 'demo-app-root' );
const root = createRoot( domNode );

root.render( <App /> );

